import React, { Component } from 'react';
import LanguageUtil from '../../util/LanguageUtil';
import Icon from '../../icons/Icon';
import ComponentName from '../../constant/ComponentName';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../RoleHelper';
import { User } from '../../domain/rbac/RbacDomains';
import SidebarMenuItem, { SidebarMenuItemProps } from './SidebarMenuItem';
import EnvironmentUtil from '../../util/EnvironmentUtil';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';

class SettingsMenu extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private footerMenu: SidebarMenuItemProps[] = [
    {
      name: LanguageUtil.get({ id: 'common.label.action', defaultMessage: 'Action' }),
      path: 'action',
      field: 'Action',
      icon: <Icon icon={'sidebar-action'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.ACTION,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.sandbox', defaultMessage: 'Sandbox' }),
      path: 'sandbox',
      field: 'Sandbox',
      icon: <Icon icon={'sidebar-sandbox'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.SANDBOX,
      visible: this.environmentUtil.getPages().sandbox,
    },
  ];

  private administrationMenu: SidebarMenuItemProps[] = [
    {
      name: LanguageUtil.get({ id: 'common.label.administration', defaultMessage: 'Administration' }),
      path: 'admin',
      field: 'Administration',
      icon: <Icon icon={'sidebar-administration'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.ADMINISTRATION,
    },
  ];

  public render() {
    const {
      collapsed,
      router,
      goPage,
      component: { module },
    } = this.props;
    const isFraudOrAml = module.includes('fraud') || module.includes('aml');
    const pathName = router.location.pathname.split('/')[1];
    const filteredMenu = this.footerMenu.filter((m) => (m.visible != undefined ? m.visible : true) && RoleHelper.canView(m.field));
    const administrationMenu = this.administrationMenu.filter((m) => (m.visible != undefined ? m.visible : true) && RoleHelper.canView(m.field));
    return (
      <div className={'flex flex-col items-center justify-end w-full h-full mb-3'}>
        <div className={'flex items-center w-full h-10 gap-x-1'}>
          <p className={`text-f-black-4 font-semibold tracking-[1.5px] ${collapsed ? 'text-center w-full' : 'ml-5'} text-sm`}>
            {collapsed ? 'S' : LanguageUtil.get({ id: 'common.label.settings', defaultMessage: 'SETTINGS' })}
          </p>
        </div>
        {filteredMenu.map(
          (m) => (m.path == 'action' || isFraudOrAml) && <SidebarMenuItem key={m.name} item={m} goPage={goPage} pathName={pathName} collapsed={collapsed} />,
        )}
        {RoleHelper.isAdmin() &&
          administrationMenu.map((m) => (
            <SidebarMenuItem key={m.name} item={m} goPage={() => goPage(this.administrationMenu[0])} pathName={pathName} collapsed={collapsed} />
          ))}
      </div>
    );
  }
}

interface Props extends ReduxProps, FormicaProps {
  goPage(m: SidebarMenuItemProps): void;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
  collapsed: state.page.sidebarCollapsed,
  page: state.page,
  component: state.component,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(SettingsMenu));
